import styled, { css } from 'styled-components';
import { MText } from '../../../../atoms/MText';
import { StyledEmbeddedWidgetCon } from '../../../skins';
import { MButton } from '../../../../atoms/MButton';
import { sanitizeThemeStyleByNumber } from '../../../../helpers/style';

export const StyledChooseVariant = styled.button`
  width: 100%;
  background: transparent;
  border: 0px;
  outline: none;
  cursor: pointer;
  padding: ${props => props.padding || '0px'};
  margin: ${props => props.margin || '0px'};
  color: ${props => props.color || 'inherit'};
  display: flex;
  align-items: center;
  justify-content: ${props => props.textAlignment || 'left'};
  font-style: ${props => props.fontStyle || 'normal'};
  font-weight: ${props => props.fontWeight || 'normal'};
  text-decoration: ${props => props.textDecoration || 'none'};
  gap: 8px;

  .choose-variant__text {
    font-size: ${props => props.fontSize || 'inherit'};
  }
`;

export const StyledVDTileEmbeddedWidgetCon = styled(StyledEmbeddedWidgetCon)`
  position: ${props =>
    props.positionRelativeDisabled ? 'static' : 'relative'};
  & .mr-embedded-widget__quantity-option-con {
    flex-wrap: wrap;
    &::-webkit-scrollbar {
      width: 0px;
      height: 0px;
    }
    ${props =>
      props.isMobile
        ? css`
            overflow-x: auto;
            overflow-y: hidden;
            max-width: 100%;
          `
        : null};
  }

  & .mr-quantity-option {
    overflow: hidden;
    align-items: center;
  }

  & .mr-vd-variant-section__selector-table {
    width: 100%;
    border-collapse: separate;
    border-spacing: 5px;
    margin-left: -5px;
    background: transparent;
  }

  & .mr-selector-table__variant-selector-cell {
    width: 100%;

    & .mr-vd-variant-selector {
      border: 1px solid #737373;
    }
  }

  & .mr-vd-variant-section__selector-table tr {
    vertical-align: text-top;
  }

  & .mr-selector-table__product-index-cell {
    padding-right: 10px !important;
  }

  & .mr-vd-variant-section__selector-table tr td {
    background: transparent;
    padding: 0px;
    border: 0px;
  }

  & .mr-vd-product-index {
    min-width: max-content;
  }

  & .mr-vd-variant-section__action-item {
    margin-top: 8px;
  }
`;

export const StyledVDOptionTileButton = styled(MButton)`
  min-width: ${props => sanitizeThemeStyleByNumber(props.width)};

  & .mr-quantity-option__banner-con {
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    overflow: hidden;
    z-index: 1;
    transform: translateY(-${props => props.height / 2}px);
  }

  .mr-quantity-option_price-text {
    text-decoration: line-through;
    line-height: 1.2;
    color: ${props => props.vdPriceTextColor};
    font-weight: ${props => props.vdPriceFontWeight};
    font-style: ${props => props.vdPriceFontStyle};
    font-size: ${props => props.vdPriceFontSize}px;
    text-align: ${props => props.vdPriceTextAlignment};
    padding: ${props => props.vdPricePadding};
    margin: ${props => props.vdPriceMargin};
  }

  .mr-quantity-option_text {
    color: ${props => props.vdOptionTextColor};
    font-weight: ${props => props.vdOptionFontWeight};
    font-style: ${props => props.vdOptionFontStyle};
    font-size: ${props => props.vdOptionFontSize}px;
    text-align: ${props => props.vdOptionTextAlignment};
    padding: ${props => props.vdOptionTextPadding};
    margin: ${props => props.vdOptionTextMargin};
    text-decoration: ${props => props.vdOptionTextDecoration};
  }

  .mr-quantity-option_per-item-text {
    color: ${props => props.vdPerItemTextColor};
    font-weight: ${props => props.vdPerItemFontWeight};
    font-style: ${props => props.vdPerItemFontStyle};
    font-size: ${props => props.vdPerItemFontSize}px;
    text-align: ${props => props.vdPerItemTextAlignment};
    padding: ${props => props.vdPerItemPadding};
    margin: ${props => props.vdPerItemMargin};
    line-height: 1.2;
  }

  .mr-quantity-option_discount-text {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 4px;
    width: fit-content;
    line-height: 1.2;
    color: ${props => props.vdOptionDiscountTextColor};
    font-weight: ${props => props.vdOptionDiscountFontWeight};
    font-style: ${props => props.vdOptionDiscountFontStyle};
    font-size: ${props => props.vdOptionDiscountFontSize}px;
    text-align: ${props => props.vdOptionDiscountTextAlignment};
    padding: ${props => props.vdOptionDiscountPadding};
    margin: ${props => props.vdOptionDiscountMargin};
    background: ${props => props.vdOptionDiscountBackgroundColor};
    border-radius: ${props => props.vdOptionDiscountBorderRadius};
  }

  .mr-quantity-option_info-con {
    gap: 3px;
    width: 100%;
    align-items: center;
    cursor: pointer;
  }

  .mr-quantity-option_offer-price-text {
    line-height: 1.2;
    color: ${props => props.vdOfferPriceTextColor};
    font-weight: ${props => props.vdOfferPriceFontWeight};
    font-style: ${props => props.vdOfferPriceFontStyle};
    font-size: ${props => props.vdOfferPriceFontSize}px;
    text-align: ${props => props.vdOfferPriceTextAlignment};
    padding: ${props => props.vdOfferPricePadding};
    margin: ${props => props.vdOfferPriceTextMargin};
  }
`;

export const InfoText = styled(MText)`
  opacity: ${props => (props.hide ? 0 : 1)};
  cursor: pointer;
  width: 100%;
`;
